import { DROPDOWN_APP_LANGUAGES } from "../constants";

export const goToUrl = (id: string) => {
  const currentItem = DROPDOWN_APP_LANGUAGES.find(item => item.id === id);

  if (currentItem?.content?.domain) {
    window.location.href = `https://${currentItem.content.domain}/`;
  }
};
